import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import React from "react";
import styled, { useTheme } from "styled-components";
import { IconProp } from "@fortawesome/fontawesome-svg-core";

interface MessageProps {
  icon: IconDefinition;
  component1: JSX.Element;
  component2?: JSX.Element;
}

const MessageContainer = styled.div`
  padding: 10px;
  display: flex;
  min-height: 72px;
  overflow: hidden;
`;

const MessageItem = styled.div`
  font-size: 18px;
`;

const MessageLeft = styled(MessageItem)`
  margin-right: 10px;
`;

const MessageRight = styled(MessageItem)`
  flex-grow: 1;
  text-align: right;
`;

const Message = (props: MessageProps): JSX.Element => {
  const theme = useTheme();
  return (
    <MessageContainer>
      <MessageLeft>
        <FontAwesomeIcon
          icon={props.icon as IconProp}
          color={theme.colors.grays3}
        />
      </MessageLeft>
      <MessageItem>{props.component1}</MessageItem>
      {props.component2 ? (
        <MessageRight>{props.component2}</MessageRight>
      ) : (
        <></>
      )}
    </MessageContainer>
  );
};

export default Message;
